import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.8334 1.3415L10.6584 0.166504L6.00008 4.82484L1.34175 0.166504L0.166748 1.3415L4.82508 5.99984L0.166748 10.6582L1.34175 11.8332L6.00008 7.17484L10.6584 11.8332L11.8334 10.6582L7.17508 5.99984L11.8334 1.3415Z" }));
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
